(function(){
  if (window.__KA_MULTIPLAYER_BOOTED__) return;
  window.__KA_MULTIPLAYER_BOOTED__ = true;

  // same-page instance registry for "stop others"
  window.__KA_MULTIPLAYER_INSTANCES__ = window.__KA_MULTIPLAYER_INSTANCES__ || new Set();

  function escapeHtml(str){
    return String(str).replace(/[&<>"']/g, (c) => ({
      "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"
    }[c]));
  }

  function getTracks(root){
    var s = root.querySelector(".multiPlayer__tracksJson");
    var raw = s ? s.textContent : "[]";
    var parsed = [];
    try { parsed = JSON.parse(raw); } catch(e){ parsed = []; console.error("Tracks JSON parse failed:", e); }

    var out = [];
    for (var i=0; i<parsed.length; i++){
      var t = parsed[i] || {};
      var name = (typeof t.name === "string" && t.name.trim()) ? t.name.trim() : ("Track " + (i+1));
      var url  = (typeof t.url === "string" && t.url.trim()) ? t.url.trim() : "";
      var peaksUrl = (typeof t.peaksUrl === "string" && t.peaksUrl.trim()) ? t.peaksUrl.trim() : "";
      if (!url){
        console.error("Missing url for track index", i, t);
        continue;
      }
      out.push({ name:name, url:url, peaksUrl: peaksUrl });
    }
    return out;
  }

  function xhrArrayBuffer(url){
    return new Promise(function(resolve, reject){
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = function(){
        if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.response);
        else reject(new Error("XHR failed (" + xhr.status + "): " + url));
      };
      xhr.onerror = function(){ reject(new Error("XHR network error: " + url)); };
      xhr.send();
    });
  }

  function playIconSvg(size){
    size = size || 22;
    return `
      <svg width="${size}" height="${size}" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="rgba(255,255,255,0.92)" d="M8 5v14l11-7z"></path>
      </svg>`;
  }
  function stopIconSvg(size){
    size = size || 22;
    return `
      <svg width="${size}" height="${size}" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="rgba(255,255,255,0.92)" d="M7 7h10v10H7z"></path>
      </svg>`;
  }

  // Peaks stored as min/max pairs per column. If you supply JSON peaks, expect same.
  function computeMinMaxPeaks(audioBuffer, columns){
    var ch0 = audioBuffer.getChannelData(0);
    var len = ch0.length;
    var step = Math.max(1, Math.floor(len / columns));
    var peaks = new Float32Array(columns * 2);

    for (var i=0; i<columns; i++){
      var start = i * step;
      var end = Math.min(start + step, len);
      var min = 1.0, max = -1.0;

      for (var j=start; j<end; j++){
        var v = ch0[j];
        if (v < min) min = v;
        if (v > max) max = v;
      }

      var scale = 0.90;
      peaks[i*2] = Math.max(-1, Math.min(1, min * scale));
      peaks[i*2+1] = Math.max(-1, Math.min(1, max * scale));
    }

    // LIGHT smoothing removed to keep it “bar-like” and less smeary.
    // (If you want more smoothing later, we can add it back as a setting.)

    return peaks;
  }

  function resizeCanvasToCSS(canvas){
    var rect = canvas.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    var w = Math.max(1, Math.round(rect.width * dpr));
    var h = Math.max(1, Math.round(rect.height * dpr));
    if (canvas.width !== w || canvas.height !== h){
      canvas.width = w;
      canvas.height = h;
    }
    return { dpr:dpr };
  }

  function cssVar(root, name, fallback){
    var v = getComputedStyle(root).getPropertyValue(name);
    v = v ? v.trim() : "";
    return v || fallback;
  }

  function toIntSafe(v, fallback){
    var n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  // Draw waveform into the canvas. Base grey + accent overlay + playhead.
  // Supports styles: "lines" | "bars" | "roundedBars"
  // Mobile polish: auto-reduces drawn columns based on available width (so it looks cleaner).
  function drawWaveWithProgress(canvas, peaks, progress01, isActive, accent, style){
    var ctx2d = canvas.getContext("2d");
    if (!ctx2d) return;

    // resize canvas to match CSS size (DPR-aware)
    var rect = canvas.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    var w = Math.max(1, Math.round(rect.width * dpr));
    var h = Math.max(1, Math.round(rect.height * dpr));
    if (canvas.width !== w || canvas.height !== h){
      canvas.width = w;
      canvas.height = h;
    } 

    ctx2d.clearRect(0, 0, w, h);

    // subtle dark veil behind waveform
    ctx2d.fillStyle = "rgba(0,0,0,0.22)";
    ctx2d.fillRect(0, 0, w, h);

    // peaks are min/max pairs per column
    var srcCols = Math.floor(peaks.length / 2);
    if (srcCols <= 0) return;

    // padding inside waveform region
    var pad = Math.floor(10 * dpr);
    var innerW = Math.max(1, w - pad * 2);

    // playhead position
    var p = Math.max(0, Math.min(1, progress01 || 0));
    var playedX = pad + Math.floor(innerW * p);

    var mid = Math.floor(h / 2);
    var maxAmp = mid - Math.floor(4 * dpr);

    // --- Mobile polish: choose fewer columns when narrow ---
    // Minimum spacing per bar in CSS px (tweak 5–9 to taste)
    var minBarPx = 6;
    var minBarDevicePx = Math.max(1, Math.floor(minBarPx * dpr));

    // bars we can draw with decent spacing
    var drawCols = Math.max(12, Math.min(srcCols, Math.floor(innerW / minBarDevicePx)));

    // map draw index -> source index (downsample when needed)
    function srcIndexForDraw(i){
      if (drawCols === srcCols) return i;
      return Math.min(srcCols - 1, Math.floor(i * srcCols / drawCols));
    }

    var step = innerW / drawCols;

    var baseCol = "rgba(255,255,255,0.12)";
    var playedCol = isActive ? (accent || "rgba(255,105,180,0.90)") : "rgba(255,255,255,0.22)";

    var drawAsLines = (style === "lines");
    var drawRounded = (style === "roundedBars");

    // Rounded bars are best drawn as strokes with round caps
    ctx2d.lineCap = drawRounded ? "round" : "butt";

    for (var i=0; i<drawCols; i++){
      var si = srcIndexForDraw(i);

      var mn = peaks[si*2];
      var mx = peaks[si*2 + 1];

      // Use a single amplitude so it reads as clean vertical bars/lines
      var amp = Math.max(Math.abs(mn), Math.abs(mx));
      amp = Math.max(0, Math.min(1, amp));

      var yTop = mid - Math.floor(amp * maxAmp);
      var yBot = mid + Math.floor(amp * maxAmp);

      var x0 = pad + Math.floor(i * step);
      var x1 = pad + Math.floor((i + 1) * step);
      var cx = Math.floor((x0 + x1) * 0.5);

      var barW = Math.max(1, x1 - x0);
      var isPlayed = (cx <= playedX);

      if (drawAsLines || drawRounded){
        // Stroke-based bars (clean + rounded)
        ctx2d.strokeStyle = isPlayed ? playedCol : baseCol;

        // thickness: proportional to available space, capped reasonably
        var lw;
        if (drawRounded){
          lw = Math.max(2 * dpr, Math.min(10 * dpr, barW * 0.65));
        } else {
          lw = Math.max(1 * dpr, Math.min(3 * dpr, barW * 0.25));
        }
        ctx2d.lineWidth = lw;

        ctx2d.beginPath();
        ctx2d.moveTo(cx, yTop);
        ctx2d.lineTo(cx, yBot);
        ctx2d.stroke();
      } else {
        // Square bars (filled rects)
        var top = yTop;
        var bot = yBot;
        var barH = Math.max(2, bot - top);

        // base
        ctx2d.fillStyle = baseCol;
        ctx2d.fillRect(x0, top, barW, barH);

        // played overlay (clip to playhead)
        if (x0 + barW <= playedX){
          ctx2d.fillStyle = playedCol;
          ctx2d.fillRect(x0, top, barW, barH);
        } else if (x0 < playedX && x0 + barW > playedX){
          var partW = Math.max(0, playedX - x0);
          ctx2d.fillStyle = playedCol;
          ctx2d.fillRect(x0, top, partW, barH);
        }
      }
    }

    // Playhead line
    ctx2d.fillStyle = "rgba(255,255,255,0.55)";
    ctx2d.fillRect(
      playedX,
      Math.floor(6 * dpr),
      Math.max(1, Math.floor(1 * dpr)),
      h - Math.floor(12 * dpr)
    );
  }


  function initOne(root){
  if (root.dataset.mpInit === "1") return;
  root.dataset.mpInit = "1";

  // ✅ IMPORTANT: read tracks BEFORE we overwrite root.innerHTML
  var tracks = getTracks(root);

  // Read config (from data-attrs + CSS vars)
  var title = root.dataset.mpTitle || "Multitrack Player";
  var description = root.dataset.mpDescription || "";
  var stopOthers = (root.dataset.mpStopOthers || "true") === "true";
  var syncMode = (root.dataset.mpSyncMode || "synced"); // synced | independent
  var waveStyle = (root.dataset.mpWaveStyle || "roundedBars"); // lines | bars | roundedBars
  var columns = toIntSafe(root.dataset.mpWaveColumns, 60);

  var accent = cssVar(root, "--mp-accent", "#ff69b4");
  var artUrl = root.getAttribute("data-mp-art") || "";

  // de-click times
  var FADE_OUT = 0.03;
  var FADE_IN  = 0.035;

  var isStopping = false;
  var isRestarting = false;

  // Build markup (this would have erased the JSON tag if we hadn't read it above)
  root.innerHTML = `
    <div class="multiPlayer__row">
      <img class="multiPlayer__art" alt="" loading="lazy" decoding="async" />
      <div class="multiPlayer__titleWrap">
        <div class="multiPlayer__title">${escapeHtml(title)}</div>
        <div class="multiPlayer__desc">${escapeHtml(description)}</div>
      </div>
      
    </div>

    <div class="multiPlayer__tracksList"></div>
  `;

  var artEl = root.querySelector(".multiPlayer__art");
  var loadEl = root.querySelector(".multiPlayer__load");
  var list = root.querySelector(".multiPlayer__tracksList");

  // Create a "loading" badge we'll mount over the first waveform
  var loadEl = document.createElement("div");
  loadEl.className = "multiPlayer__load";
  loadEl.setAttribute("aria-live", "polite");


  // Artwork: hide if none
  if (!artUrl){
    artEl.style.display = "none";
  } else {
    artEl.src = artUrl;
    var useVh = String(cssVar(root, "--mp-artUseVh", "true")).trim() === "true";
    if (useVh){
      artEl.style.width  = "var(--mp-artVh, 10vh)";
      artEl.style.height = "var(--mp-artVh, 10vh)";
    } else {
      artEl.style.width  = "var(--mp-artPx, 80px)";
      artEl.style.height = "var(--mp-artPx, 80px)";
    }
  }

  // Helpers
  function setLoading(msg){
    if (!msg){
      loadEl.textContent = "";
      loadEl.classList.remove("is-visible");
      return;
    }
    loadEl.textContent = msg;
    loadEl.classList.add("is-visible");
  }

  // Now we can safely show "No tracks" if needed
  if (!tracks.length){
    setLoading("No tracks");
    return;
  }

  // Instance registry for stop-others
  var instance = {
    root: root,
    stop: function(){ stopPlayback(); },
    isPlaying: function(){ return isPlaying; }
  };
  window.__KA_MULTIPLAYER_INSTANCES__.add(instance);

  function stopOtherPlayers(){
    if (!stopOthers) return;
    window.__KA_MULTIPLAYER_INSTANCES__.forEach(function(inst){
      if (inst !== instance && inst.isPlaying && inst.isPlaying()){
        try { inst.stop(); } catch(e){}
      }
    });
  }

  // ===== WebAudio state =====
  var ctx = null;
  var masterGain = null;

  var buffers = [];
  var gains = [];    // synced mode only
  var sources = [];  // synced mode only

  // independent mode uses a single source/gain
  var oneGain = null;
  var oneSource = null;

  var onePlayToken = 0; // increments each time we start a new independent source

  var activeIndex = 0;
  var isPlaying = false;

  var decodeDone = false;

  // synced mode:
  var loopDurSec = 0.0;
  var pausedOffset = 0.0;
  var startCtxTime = 0.0;

  // independent mode:
  var oneStartCtxTime = 0.0;
  var onePausedOffset = 0.0;

  // waveform
  var peaksByIndex = new Array(tracks.length).fill(null);

  // preload caches
  var preloadedArrayBuffers = new Array(tracks.length).fill(null);
  var peaksFetched = false;
  var audioFetched = false;

  var rafId = 0;

  function ensureContext(){
    if (!ctx){
      var AC = window.AudioContext || window.webkitAudioContext;
      ctx = new AC({ latencyHint: "interactive" });

      masterGain = ctx.createGain();
      masterGain.gain.value = 1;
      masterGain.connect(ctx.destination);
    }
    return ctx;
  }

  function rampMaster(to, seconds){
    if (!ctx || !masterGain) return;
    var now = ctx.currentTime;
    masterGain.gain.cancelScheduledValues(now);
    masterGain.gain.setValueAtTime(masterGain.gain.value, now);
    masterGain.gain.linearRampToValueAtTime(to, now + seconds);
  }

  function getProgress01ForRow(i){
    if (!decodeDone) return 0;

    if (syncMode === "synced"){
      if (loopDurSec <= 0) return 0;
      if (ctx && isPlaying){
        var t = ctx.currentTime - startCtxTime;
        if (t < 0) t = 0;
        return (t % loopDurSec) / loopDurSec;
      }
      return (pausedOffset % loopDurSec) / loopDurSec;
    }

    // independent: only active row advances
    if (i !== activeIndex) return 0;

    var dur = buffers[activeIndex] ? buffers[activeIndex].duration : 0;
    if (dur <= 0) return 0;

    if (ctx && isPlaying){
      var tt = ctx.currentTime - oneStartCtxTime;
      if (tt < 0) tt = 0;
      return Math.max(0, Math.min(1, tt / dur));
    }
    return Math.max(0, Math.min(1, onePausedOffset / dur));
  }

  function drawAllRows(){
    var rows = list.querySelectorAll(".multiPlayer__track");
    rows.forEach(function(row, i){
      var canvas = row.querySelector(".multiPlayer__wave");
      var peaks = peaksByIndex[i];
      if (!canvas || !peaks) return;

      var prog = getProgress01ForRow(i);
      drawWaveWithProgress(canvas, peaks, prog, (i === activeIndex), accent, waveStyle);
    });
  }

  function renderTracks(){
    list.innerHTML = "";
    for (var i=0; i<tracks.length; i++){
      var t = tracks[i];

      var row = document.createElement("div");
      row.className = "multiPlayer__track" + (i === activeIndex ? " is-active" : "");
      row.dataset.index = String(i);

      row.innerHTML = `
        <div class="multiPlayer__trackFg">
          <div class="multiPlayer__iconBtn" data-role="icon">
            ${(isPlaying && i === activeIndex) ? stopIconSvg(24) : playIconSvg(24)}
          </div>
          <div class="multiPlayer__trackName">${escapeHtml(t.name)}</div>
        </div>
        <div class="multiPlayer__waveWrap">
          <canvas class="multiPlayer__wave"></canvas>
        </div>
      `;

      (function(idx, rowEl){
        var icon = rowEl.querySelector('[data-role="icon"]');
        icon.addEventListener("click", function(ev){
          ev.stopPropagation();
          onIconClick(idx).catch(console.error);
        });

        rowEl.addEventListener("click", function(){
          onRowClick(idx).catch(console.error);
        });

        var canvas = rowEl.querySelector(".multiPlayer__wave");
        canvas.addEventListener("click", function(ev){
          ev.stopPropagation();
          onWaveClick(idx, ev).catch(console.error);
        });
      })(i, row);

      list.appendChild(row);
    }
    // Mount loader over the FIRST track waveform (after rows exist)
    var firstWaveWrap = list.querySelector(".multiPlayer__track .multiPlayer__waveWrap");
    if (firstWaveWrap){
      // ensure waveWrap is positioning context
      // (it already is in CSS: position: relative;)
      if (loadEl.parentElement !== firstWaveWrap){
        firstWaveWrap.appendChild(loadEl);
      }
    }


    drawAllRows();
  }

  function setActive(i){
    if (i < 0 || i >= tracks.length) return;

    var prev = activeIndex;
    activeIndex = i;

    // ✅ Individual mode: selecting a different track always resets to beginning
    if (syncMode === "independent" && i !== prev){
      onePausedOffset = 0;
    }

    // synced: crossfade between gains (unchanged)
    if (syncMode === "synced" && ctx && gains.length){
      var fade = 0.02;
      var now = ctx.currentTime;
      for (var k=0; k<gains.length; k++){
        var g = gains[k].gain;
        var target = (k === activeIndex) ? 1 : 0;
        g.cancelScheduledValues(now);
        g.setValueAtTime(g.value, now);
        g.linearRampToValueAtTime(target, now + fade);
      }
    }

    renderTracks();
  }


  // ===== Preload on scroll-near =====
  function setupPreloadObserver(){
    if (!("IntersectionObserver" in window)) return;

    var io = new IntersectionObserver(function(entries){
      for (var i=0; i<entries.length; i++){
        if (!entries[i].isIntersecting) continue;
        io.disconnect();
        preloadNearView().catch(function(e){ console.warn("Preload failed:", e); });
        break;
      }
    }, { root: null, rootMargin: "600px 0px", threshold: 0.01 });

    io.observe(root);
  }

  async function preloadNearView(){
    await preloadPeaksIfAvailable();
    await preloadAudioBytes();
    drawAllRows();
  }

  async function preloadPeaksIfAvailable(){
    if (peaksFetched) return;

    var anyPeaks = tracks.some(function(t){ return !!t.peaksUrl; });
    if (!anyPeaks){ peaksFetched = true; return; }

    for (let i=0; i<tracks.length; i++){
      if (!tracks[i].peaksUrl) continue;
      try{
        var res = await fetch(tracks[i].peaksUrl, { cache: "force-cache" });
        if (!res.ok) throw new Error("peaks fetch failed: " + res.status);
        var data = await res.json();
        if (data && Array.isArray(data.peaks)){
          peaksByIndex[i] = new Float32Array(data.peaks);
        }
        drawAllRows();
      } catch(e){
        console.warn("Peaks preload failed for track", i, e);
      }
    }

    peaksFetched = true;
  }

  async function preloadAudioBytes(){
    if (audioFetched) return;
    for (let i=0; i<tracks.length; i++){
      if (preloadedArrayBuffers[i]) continue;
      try{
        preloadedArrayBuffers[i] = await xhrArrayBuffer(tracks[i].url);
      } catch(e){
        console.warn("Audio byte preload failed for track", i, e);
      }
    }
    audioFetched = true;
  }

  // ===== Decode buffers =====
  async function ensureDecoded(){
    ensureContext();
    if (ctx.state === "suspended") await ctx.resume();
    if (decodeDone) return;

    buffers = [];

    for (let i=0; i<tracks.length; i++){
      setLoading("Loading " + (i+1) + "/" + tracks.length);

      var ab = preloadedArrayBuffers[i] || await xhrArrayBuffer(tracks[i].url);

      var buf = await new Promise(function(resolve, reject){
        ctx.decodeAudioData(ab, resolve, reject);
      });
      buffers.push(buf);

      if (!peaksByIndex[i]){
        peaksByIndex[i] = computeMinMaxPeaks(buf, columns);
      }

      drawAllRows();
    }

    if (syncMode === "synced"){
      loopDurSec = buffers.reduce(function(min, b){ return Math.min(min, b.duration || min); }, buffers[0].duration);
      loopDurSec = Math.max(0.1, loopDurSec);
    }

    decodeDone = true;
    setLoading("");
    renderTracks();
  }

  // ===== Synced playback graph =====
  function buildSyncedGraphAndStartAt(offsetSec, when){
    gains = [];
    sources = [];

    for (var i=0; i<buffers.length; i++){
      var gain = ctx.createGain();
      gain.gain.value = (i === activeIndex) ? 1 : 0;
      gain.connect(masterGain);
      gains.push(gain);

      var src = ctx.createBufferSource();
      src.buffer = buffers[i];
      src.loop = true;
      src.loopStart = 0;
      src.loopEnd = loopDurSec;
      src.connect(gain);
      sources.push(src);
    }

    startCtxTime = when - offsetSec;

    for (var k=0; k<sources.length; k++){
      sources[k].start(when, offsetSec % loopDurSec);
    }
  }

  // ===== Independent playback =====
  function startIndependentAt(offsetSec){
    // stop any existing source
    if (oneSource){
      try { oneSource.stop(); } catch(e){}
      oneSource = null;
    }

    oneGain = ctx.createGain();
    oneGain.gain.value = 1;
    oneGain.connect(masterGain);

    oneSource = ctx.createBufferSource();
    oneSource.buffer = buffers[activeIndex];
    oneSource.loop = false;
    oneSource.connect(oneGain);

    var when = ctx.currentTime + 0.02;
    oneStartCtxTime = when - offsetSec;

    // ✅ token guard
    onePlayToken += 1;
    var myToken = onePlayToken;
    var mySource = oneSource;

    oneSource.onended = function(){
      // ignore stale callbacks from old sources
      if (syncMode !== "independent") return;
      if (myToken !== onePlayToken) return;
      if (mySource !== oneSource) return;

      if (isPlaying){
        isPlaying = false;
        onePausedOffset = 0;
        renderTracks();
      }
    };

    oneSource.start(when, Math.max(0, offsetSec));
  }


  var isSwitchingIndependent = false;

async function switchIndependentTo(newIndex){
  if (isSwitchingIndependent) return;
  isSwitchingIndependent = true;

  stopOtherPlayers();
  await ensureDecoded();
  if (ctx.state === "suspended") await ctx.resume();

  // select track + reset start position
  setActive(newIndex);
  onePausedOffset = 0;

  // If nothing is playing, just start immediately at 0
  if (!isPlaying){
    if (masterGain) masterGain.gain.value = 0;
    startIndependentAt(0);
    masterGain.gain.cancelScheduledValues(ctx.currentTime);
    masterGain.gain.setValueAtTime(0, ctx.currentTime);
    masterGain.gain.linearRampToValueAtTime(1, ctx.currentTime + FADE_IN);
    isPlaying = true;
    if (!rafId) rafId = requestAnimationFrame(tick);
    renderTracks();
    isSwitchingIndependent = false;
    return;
  }

  // If playing: fade out current audio, stop old source, start new one, fade in.
  var now = ctx.currentTime;

  // Fade out current
  rampMaster(0, FADE_OUT);
  var stopAt  = now + FADE_OUT + 0.002;
  var startAt = stopAt + 0.01;

  // Stop old source at stopAt
  if (oneSource){
    try { oneSource.stop(stopAt); } catch(e){}
  }
  oneSource = null;
  oneGain = null;

  // Start new source at startAt (silent until fade in)
  // We'll reuse startIndependentAt, but it uses ctx.currentTime internally,
  // so we make a scheduled variant here to start exactly at startAt.
  oneGain = ctx.createGain();
  oneGain.gain.value = 1;
  oneGain.connect(masterGain);

  oneSource = ctx.createBufferSource();
  oneSource.buffer = buffers[activeIndex];
  oneSource.loop = false;
  oneSource.connect(oneGain);

  oneStartCtxTime = startAt; // starting at 0, so start time equals startAt

  onePlayToken += 1;
  var myToken = onePlayToken;
  var mySource = oneSource;

  oneSource.onended = function(){
    if (syncMode !== "independent") return;
    if (myToken !== onePlayToken) return;
    if (mySource !== oneSource) return;

    if (isPlaying){
      isPlaying = false;
      onePausedOffset = 0;
      renderTracks();
    }
  };

  oneSource.start(startAt, 0);

  // Fade back in after start
  masterGain.gain.cancelScheduledValues(now);
  masterGain.gain.setValueAtTime(masterGain.gain.value, now);
  masterGain.gain.setValueAtTime(0, stopAt);
  masterGain.gain.linearRampToValueAtTime(1, startAt + FADE_IN);

  isPlaying = true;
  if (!rafId) rafId = requestAnimationFrame(tick);
  renderTracks();

  // Unlock quickly
  setTimeout(function(){
    isSwitchingIndependent = false;
  }, Math.ceil((FADE_OUT + FADE_IN + 0.06) * 1000));
}

async function seekIndependentTo(newIndex, offsetSec){
  if (isSwitchingIndependent) return;
  isSwitchingIndependent = true;

  stopOtherPlayers();
  await ensureDecoded();
  if (ctx.state === "suspended") await ctx.resume();

  // select track
  setActive(newIndex);

  // clamp offset
  var dur = buffers[activeIndex] ? buffers[activeIndex].duration : 0;
  if (dur > 0){
    offsetSec = Math.max(0, Math.min(dur - 0.001, offsetSec));
  } else {
    offsetSec = 0;
  }

  // Fade out current audio if playing
  var now = ctx.currentTime;
  var stopAt = now;

  if (isPlaying){
    rampMaster(0, FADE_OUT);
    stopAt = now + FADE_OUT + 0.002;

    if (oneSource){
      try { oneSource.stop(stopAt); } catch(e){}
    }
  } else {
    // if stopped, ensure we start from silence
    if (masterGain) masterGain.gain.value = 0;
  }

  // schedule new start shortly after stop
  var startAt = stopAt + 0.01;

  // clear current nodes
  oneSource = null;
  oneGain = null;

  // build new source
  oneGain = ctx.createGain();
  oneGain.gain.value = 1;
  oneGain.connect(masterGain);

  oneSource = ctx.createBufferSource();
  oneSource.buffer = buffers[activeIndex];
  oneSource.loop = false;
  oneSource.connect(oneGain);

  // token guard (prevents stale onended from clobbering UI)
  onePlayToken += 1;
  var myToken = onePlayToken;
  var mySource = oneSource;

  oneSource.onended = function(){
    if (syncMode !== "independent") return;
    if (myToken !== onePlayToken) return;
    if (mySource !== oneSource) return;

    if (isPlaying){
      isPlaying = false;
      onePausedOffset = 0;
      renderTracks();
    }
  };

  // Start at requested offset
  oneStartCtxTime = startAt - offsetSec;
  onePausedOffset = offsetSec;

  oneSource.start(startAt, offsetSec);

  // Fade in
  masterGain.gain.cancelScheduledValues(now);
  masterGain.gain.setValueAtTime(0, now);
  masterGain.gain.setValueAtTime(0, startAt);
  masterGain.gain.linearRampToValueAtTime(1, startAt + FADE_IN);

  isPlaying = true;
  if (!rafId) rafId = requestAnimationFrame(tick);

  renderTracks();

  setTimeout(function(){
    isSwitchingIndependent = false;
  }, Math.ceil((FADE_OUT + FADE_IN + 0.08) * 1000));
}



  function tick(){
    drawAllRows();
    rafId = requestAnimationFrame(tick);
  }

  function stopPlayback(){
    if (!ctx) return;
    if (!isPlaying) return;
    if (isStopping || isRestarting) return;

    isStopping = true;

    cancelAnimationFrame(rafId);
    rafId = 0;

    if (syncMode === "synced"){
      pausedOffset = Math.max(0, ctx.currentTime - startCtxTime);
    } else {
      onePausedOffset = Math.max(0, ctx.currentTime - oneStartCtxTime);
    }

    rampMaster(0, FADE_OUT);
    var stopAt = ctx.currentTime + FADE_OUT + 0.002;

    if (syncMode === "synced"){
      var oldSources = sources.slice();
      for (var i=0; i<oldSources.length; i++){
        try { oldSources[i].stop(stopAt); } catch(e){}
      }
      sources = [];
      gains = [];
    } else {
      if (oneSource){
        try { oneSource.stop(stopAt); } catch(e){}
      }
      oneSource = null;
      oneGain = null;
    }

    isPlaying = false;

    setTimeout(function(){
      isStopping = false;
      renderTracks();
    }, Math.ceil((FADE_OUT + 0.03) * 1000));
  }

  async function startPlayback(){
    stopOtherPlayers();

    await ensureDecoded();
    if (ctx.state === "suspended") await ctx.resume();
    if (isStopping || isRestarting) return;

    if (!isPlaying){
      if (masterGain) masterGain.gain.value = 0;

      if (syncMode === "synced"){
        var when = ctx.currentTime + 0.05;
        buildSyncedGraphAndStartAt(pausedOffset, when);
        masterGain.gain.cancelScheduledValues(ctx.currentTime);
        masterGain.gain.setValueAtTime(0, ctx.currentTime);
        masterGain.gain.linearRampToValueAtTime(1, when + FADE_IN);
      } else {
        startIndependentAt(onePausedOffset);
        masterGain.gain.cancelScheduledValues(ctx.currentTime);
        masterGain.gain.setValueAtTime(0, ctx.currentTime);
        masterGain.gain.linearRampToValueAtTime(1, ctx.currentTime + FADE_IN);
      }

      isPlaying = true;
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    renderTracks();
  }

  function restartSyncedFrom(offsetSec){
    if (!ctx || !decodeDone) return;
    if (isRestarting) return;
    isRestarting = true;

    rampMaster(0, FADE_OUT);

    var oldSources = sources.slice();
    var now = ctx.currentTime;
    var stopAt = now + FADE_OUT + 0.001;

    for (var i=0; i<oldSources.length; i++){
      try { oldSources[i].stop(stopAt); } catch(e){}
    }

    var startAt = stopAt + 0.01;

    sources = [];
    gains = [];

    pausedOffset = offsetSec;

    buildSyncedGraphAndStartAt(pausedOffset, startAt);

    var SETTLE = 0.025;
    masterGain.gain.cancelScheduledValues(now);
    masterGain.gain.setValueAtTime(0, now);
    masterGain.gain.setValueAtTime(0, startAt + SETTLE);
    masterGain.gain.linearRampToValueAtTime(1, startAt + SETTLE + FADE_IN);

    isPlaying = true;
    if (!rafId) rafId = requestAnimationFrame(tick);

    renderTracks();

    setTimeout(function(){
      isRestarting = false;
    }, Math.ceil((FADE_OUT + FADE_IN + 0.06) * 1000));
  }

  async function onRowClick(i){
  // ===== Individual (unsynced) mode =====
    if (syncMode === "independent"){
      // Clicking a different track should immediately play that track from 0
      if (i !== activeIndex){
        await switchIndependentTo(i);
        return;
      }

      // Clicking the same track toggles stop/play (resume)
      if (isPlaying){
        stopPlayback(); // stores onePausedOffset for resume
        return;
      }

      // Start/resume same track
      await startPlayback();
      return;
    }

    // ===== Synced mode =====
    if (i !== activeIndex){
      setActive(i);

      // NEW: if we are stopped, switching tracks should start from the beginning
      if (!isPlaying){
        pausedOffset = 0;
      }

      await startPlayback();
      return;
    }

    if (isPlaying) stopPlayback();
    else await startPlayback();

  }



  async function onIconClick(i){
    await onRowClick(i);
  }

  function seekOffsetFromWaveClick(ev, durationSec){
    var canvas = ev.currentTarget;
    var rect = canvas.getBoundingClientRect();
    var padCss = 10;

    var innerLeft = rect.left + padCss;
    var innerRight = rect.right - padCss;
    var innerW = Math.max(1, innerRight - innerLeft);

    var px = Math.max(0, Math.min(innerW, ev.clientX - innerLeft));
    var frac = px / innerW;

    return frac * durationSec;
  }

  async function onWaveClick(i, ev){
    stopOtherPlayers();
    await ensureDecoded();

    if (syncMode === "independent"){
      await ensureDecoded();

      // If clicking waveform on an unselected track:
      // behave like row-click (select + play from beginning)
      if (i !== activeIndex){
        await switchIndependentTo(i); // this resets to 0 and starts immediately
        return;
      }

      // Clicking waveform on the selected track: seek
      var dur = buffers[activeIndex] ? buffers[activeIndex].duration : 0;
      var newOffset = seekOffsetFromWaveClick(ev, dur);
      await seekIndependentTo(activeIndex, newOffset);
      return;
    }



    if (!isPlaying){
      setActive(i);
      pausedOffset = 0;
      restartSyncedFrom(0);
      return;
    }

    var newOff = seekOffsetFromWaveClick(ev, loopDurSec);
    setActive(i);
    pausedOffset = newOff;
    restartSyncedFrom(newOff);
  }

  // Resize redraw
  var resizeTimer = null;
  window.addEventListener("resize", function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(drawAllRows, 120);
  });

  // Init render
  renderTracks();
  setupPreloadObserver();
}


  function boot(){
    document.querySelectorAll(".multiPlayer").forEach(initOne);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("variant:change", boot);
})();
